import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BasicECharts from 'components/common/BasicEChart';
import React, { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Badge, Card, Form, Col, Row, Spinner } from 'react-bootstrap';
import * as echarts from 'echarts/core';
import { LineChart } from 'echarts/charts';
import {
  GridComponent,
  ToolboxComponent,
  TitleComponent
} from 'echarts/components';

import { CanvasRenderer } from 'echarts/renderers';

import classNames from 'classnames';

import holdTicket from 'assets/img/support-desk/hold-tickets.png';
import openTicket from 'assets/img/support-desk/open-tickets.png';
import dueTicket from 'assets/img/support-desk/due-tickets.png';
import unassigned from 'assets/img/support-desk/unassigned.png';
import { getDashboardTicketStatus } from 'functions/dashboard';
import DatePicker from 'react-datepicker';
import moment from 'moment';

echarts.use([
  GridComponent,
  ToolboxComponent,
  TitleComponent,
  LineChart,
  CanvasRenderer
]);

const getOptions = data => ({
  tooltip: {
    trigger: 'axis',
    formatter: '{b0} : {c0}'
  },
  xAxis: {
    data: ['', '']
  },
  series: [
    {
      type: 'line',
      data: data.dataArray,
      color: data.chartColor,
      smooth: true,
      lineStyle: {
        width: 2
      },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color:
                data.chartColor === '#2c7be5'
                  ? 'rgba(44, 123, 229, .25)'
                  : data.chartColor === '#00d27a'
                    ? 'rgba(0, 210, 122, .25)'
                    : data.chartColor === '#27bcfd'
                      ? 'rgba(39, 188, 253, .25)'
                      : 'rgba(245, 128, 62, .25)'
            },
            {
              offset: 1,
              color:
                data.chartColor === '#2c7be5'
                  ? 'rgba(44, 123, 229, 0)'
                  : data.chartColor === '#00d27a'
                    ? 'rgba(0, 210, 122, 0)'
                    : data.chartColor === '#27bcfd'
                      ? 'rgba(39, 188, 253, 0)'
                      : 'rgba(245, 128, 62, 0)'
            }
          ]
        }
      }
    }
  ],
  grid: {
    bottom: '2%',
    top: '2%',
    right: '0',
    left: '0px'
  }
});





const SingleItem = ({ singleData }) => {
  return (
    <Col lg={4} md={6} className={classNames('p-3 border-bottom border-md-bottom-0', singleData.className)}>
      <Row className="g-0">
        <Col xs={12} className="text-center">
          <div className="d-flex align-items-center justify-content-center">
            {singleData.loadingIcon ? (
              <FontAwesomeIcon icon="spinner" className={`text-${singleData.color} me-2`} style={{ fontSize: '32px' }} />
            ) : (
              <img src={singleData.img} alt="" width="39" className="me-2" />
            )}
            <h2 className="mb-0 text-700 fw-normal">
              {singleData.count}
              <Badge
                pill
                bg="transparent"
                className={`text-${singleData.color} fs--1 px-2`}
              >
                <FontAwesomeIcon icon={singleData.icon} className="me-1" />
                {singleData.percentage}
              </Badge>
            </h2>
          </div>
          <h6 className="mb-0 mt-2">{singleData.title}</h6>
        </Col>
      </Row>
    </Col>
  );
};

SingleItem.propTypes = {
  singleData: PropTypes.shape({
    title: PropTypes.string,
    color: PropTypes.string,
    img: PropTypes.string,
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    percentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    icon: PropTypes.string,
    className: PropTypes.string
  })
};

const GreetingsDateInput = forwardRef(({ value, onClick }, ref) => (
  <div className="position-relative">
    <Form.Control
      size="sm"
      ref={ref}
      onClick={onClick}
      value={value}
      className="ps-4"
      onChange={e => {
        console.log({ e });
      }}
    />
    <FontAwesomeIcon
      icon="calendar-alt"
      className="text-primary position-absolute top-50 translate-middle-y ms-2"
    />
  </div>
));


const TicketStatus = ({ companyId, fromDate, toDate }) => {
  const token = localStorage.getItem('token');



  const [data, setData] = useState([
    {
      color: 'primary',
      img: holdTicket,
      percentage: '0%',
      count: '0',
      title: 'In Progress',
      icon: 'caret-up',
      loadingIcon: true,
      className: 'border-end-md'
    },
    {
      color: 'success',
      img: openTicket,
      percentage: '0%',
      count: '0',
      title: 'Closed',
      icon: 'caret-up',
      className: 'border-end-lg'
    },
    {
      color: 'info',
      img: dueTicket,
      percentage: '0%',
      count: '0',
      title: 'Not-Accepted',
      icon: 'caret-down',
      className: 'border-end-md border-end-lg-0'
    },
    {
      color: 'warning',
      img: unassigned,
      percentage: '0%',
      count: '0',
      title: 'Not-Assigned',
      icon: 'caret-up',
      className: 'border-end-lg'
    },
    {
      color: 'danger',
      img: holdTicket,
      percentage: '0%',
      count: '0',
      title: 'Pending',
      icon: 'caret-up',
      className: ''
    }
  ]);


  useEffect(() => {
    loadData();
  }, [companyId, fromDate, toDate])

  const loadData = async () => {
    const fDate = moment(fromDate).format('YYYY-MM-DD');
    const tDate = moment(toDate).format('YYYY-MM-DD');
    const results = await getDashboardTicketStatus(companyId, fDate, tDate, token);
    console.log('loaddae', results.length)

    let total = 0;
    let inprogressPrec = 0;
    let closedPrec = 0;
    let notAcceptedPrec = 0;
    let notAssignededPrec = 0;
    let pendingPrec = 0;

    let inprogressValue = 0;
    let closedValue = 0;
    let notAcceptedValue = 0;
    let notAssignededValue = 0;
    let pendingValue = 0;

    if (results.length > 0) {
      total = results.length > 0 ? (results[0].count + results[1].count + results[2].count + results[3].count) : 0;
      inprogressPrec = results[1].count > 0 ? ((results[1].count / total) * 100) : 0;
      closedPrec = results[0].count > 0 ? ((results[0].count / total) * 100) : 0;
      notAcceptedPrec = results[3].count > 0 ? ((results[3].count / total) * 100) : 0;
      notAssignededPrec = results[2].count > 0 ? ((results[2].count / total) * 100) : 0;

      inprogressValue = results[1].count;
      closedValue = results[0].count;
      notAcceptedValue = results[3].count;
      notAssignededValue = results[2].count;
      
      pendingValue = inprogressValue + notAcceptedValue + notAssignededValue;
      pendingPrec = pendingValue > 0 ? ((pendingValue / total) * 100) : 0;
    }


    const updatedData = [...data]
    updatedData[0] = { ...updatedData[0], count: inprogressValue, title: "In Progress", percentage: `${inprogressPrec.toFixed(2)}%` }
    updatedData[1] = { ...updatedData[1], count: closedValue, title: "Closed", percentage: `${closedPrec.toFixed(2)}%` }
    updatedData[2] = { ...updatedData[2], count: notAcceptedValue, title: "Not-Accepted", percentage: `${notAcceptedPrec.toFixed(2)}%` }
    updatedData[3] = { ...updatedData[3], count: notAssignededValue, title: "Not-Assigned", percentage: `${notAssignededPrec.toFixed(2)}%` }
    updatedData[4] = { ...updatedData[4], count: pendingValue, title: "Pending", percentage: `${pendingPrec.toFixed(2)}%` }
    
    setData(updatedData);
    // console.log('loaddata',res);
  }



  return (
    <Card className="h-100">
      <Card.Body>

        <Row className="g-0">
          {data && data.map(item => (
            <SingleItem key={item.title} singleData={item} />
          ))}
        </Row>
      </Card.Body>

    </Card>
  );
};

TicketStatus.propTypes = {
  companyId: PropTypes.string,
  fromDate: PropTypes.instanceOf(Date),
  toDate: PropTypes.instanceOf(Date)
};

export default TicketStatus;
